import React from "react";
import styles from './pmndp-enhanced.module.css';

const PMNDPMainModal = ({ onClosePMNDPMainModal, onSelect }) => {

    return (
        <>
            <div className="pmndp-modal-overlay">
                <div className="pmndp-modal pmndp-slide-up">
                    <div className="pmndp-modal-header">
                        <div className="pmndp-header-left">
                            <div className="pmndp-icon">
                                <img src="/images/PMNDP-logo.png" alt="PMNDP" />
                            </div>
                            <h5 className="pmndp-modal-title">PMNDP Dashboard</h5>
                        </div>
                        <button 
                            type="button" 
                            className="pmndp-modal-close" 
                            onClick={onClosePMNDPMainModal}
                            aria-label="Close"
                        >
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                    
                    <div className="pmndp-modal-body">
                        <div className="pmndp-stats-grid">
                            <div className="pmndp-stat-card">
                                <div className="pmndp-stat-value">24</div>
                                <div className="pmndp-stat-label">Active Patients</div>
                            </div>
                            <div className="pmndp-stat-card">
                                <div className="pmndp-stat-value">8</div>
                                <div className="pmndp-stat-label">Scheduled Today</div>
                            </div>
                            <div className="pmndp-stat-card">
                                <div className="pmndp-stat-value">3</div>
                                <div className="pmndp-stat-label">In Progress</div>
                            </div>
                        </div>
                        
                        <div className="pmndp-quick-actions">
                            <button 
                                className="pmndp-quick-action-btn"
                                onClick={() => { onSelect('Add New Patient'); }}
                            >
                                <i className="fa fa-user-plus"></i>
                                Add New Patient
                            </button>
                            
                            <button 
                                className="pmndp-quick-action-btn"
                                onClick={() => { onSelect('Dialysis History'); }}
                            >
                                <i className="fa fa-history"></i>
                                Dialysis History
                            </button>
                            
                            <button 
                                className="pmndp-quick-action-btn"
                                onClick={() => { onSelect('Machine Management'); }}
                            >
                                <i className="fa fa-cogs"></i>
                                Machine Management
                            </button>
                        </div>
                        
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginTop: '30px' }}>
                            <div 
                                className="pmndp-action-card"
                                onClick={() => { onSelect('Add New Patient'); }}
                                style={{
                                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                    color: 'white',
                                    padding: '30px 20px',
                                    borderRadius: '15px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    textAlign: 'center',
                                    boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-5px)';
                                    e.target.style.boxShadow = '0 8px 25px rgba(16, 185, 129, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.3)';
                                }}
                            >
                                <div style={{ fontSize: '48px', marginBottom: '15px' }}>
                                    <i className="fa fa-user-plus"></i>
                                </div>
                                <h5 style={{ margin: '0 0 10px 0', fontSize: '18px', fontWeight: '700' }}>Add New Patient</h5>
                                <p style={{ margin: '0', fontSize: '14px', opacity: '0.9' }}>Register new patients for dialysis treatment</p>
                            </div>
                            
                            <div 
                                className="pmndp-action-card"
                                onClick={() => { onSelect('Dialysis History'); }}
                                style={{
                                    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                                    color: 'white',
                                    padding: '30px 20px',
                                    borderRadius: '15px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    textAlign: 'center',
                                    boxShadow: '0 4px 15px rgba(59, 130, 246, 0.3)'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-5px)';
                                    e.target.style.boxShadow = '0 8px 25px rgba(59, 130, 246, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(59, 130, 246, 0.3)';
                                }}
                            >
                                <div style={{ fontSize: '48px', marginBottom: '15px' }}>
                                    <i className="fa fa-history"></i>
                                </div>
                                <h5 style={{ margin: '0 0 10px 0', fontSize: '18px', fontWeight: '700' }}>Dialysis History</h5>
                                <p style={{ margin: '0', fontSize: '14px', opacity: '0.9' }}>View patient treatment history and records</p>
                            </div>
                            
                            <div 
                                className="pmndp-action-card"
                                onClick={() => { onSelect('Machine Management'); }}
                                style={{
                                    background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                                    color: 'white',
                                    padding: '30px 20px',
                                    borderRadius: '15px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    textAlign: 'center',
                                    boxShadow: '0 4px 15px rgba(139, 92, 246, 0.3)'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-5px)';
                                    e.target.style.boxShadow = '0 8px 25px rgba(139, 92, 246, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(139, 92, 246, 0.3)';
                                }}
                            >
                                <div style={{ fontSize: '48px', marginBottom: '15px' }}>
                                    <i className="fa fa-cogs"></i>
                                </div>
                                <h5 style={{ margin: '0 0 10px 0', fontSize: '18px', fontWeight: '700' }}>Machine Management</h5>
                                <p style={{ margin: '0', fontSize: '14px', opacity: '0.9' }}>Manage dialysis machines and slots</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PMNDPMainModal;
